import { render } from "./SoftSnackbar.vue?vue&type=template&id=2de24c57&scoped=true"
import script from "./SoftSnackbar.vue?vue&type=script&lang=js"
export * from "./SoftSnackbar.vue?vue&type=script&lang=js"

import "./SoftSnackbar.vue?vue&type=style&index=0&id=2de24c57&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de24c57"]])

export default __exports__